import "./App.css";
import Header from "./components/header/Header";
import Card from "./components/card/Card";

const App = () => {
  return (
    <div className="main-container">
      <Header />
      <Card />
    </div>
  );
};

export default App;
